/* Wodhaus — gaveta do carrinho (14/10/2026).
   A lógica é a da Lugino/Livena/Moopey (seguro instantâneo, sugestões com variantes, degraus na moeda do
   cliente, cronómetro), refeita para o Horizon. O Horizon redesenha a gaveta sozinho quando recebe um
   «cart lines update» com as secções já desenhadas — por isso aqui só se faz o pedido ao /cart/*.js com
   `sections` e se avisa o tema com o mesmo evento que o botão de compra usa. O dinheiro e as línguas
   ficam com o Liquid. */
import { CartLinesUpdateEvent } from '@shopify/events';

const ss = {
  get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
  set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* janela privada */ } },
};

function rotas() {
  const r = (window.Theme && window.Theme.routes) || {};
  const base = (r.cart_url || '/cart').replace(/\/$/, '');
  return {
    add: r.cart_add_url || base + '/add.js',
    update: (r.cart_update_url || base + '/update') + '.js',
    clear: base + '/clear.js',
    cart: base + '.js',
  };
}

function seccoes() {
  const ids = [];
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el.dataset.sectionId && !ids.includes(el.dataset.sectionId)) ids.push(el.dataset.sectionId);
  });
  return ids;
}

/* ---------- um pedido, e o tema redesenha ----------
   Os pedidos vão em fila: dois cliques seguidos no seguro não se cruzam. */
let fila = Promise.resolve();
function mexer(origem, url, corpo, accao, linhas) {
  const tarefa = async () => {
    const adiado = CartLinesUpdateEvent.createPromise();
    (origem && origem.isConnected ? origem : document.body).dispatchEvent(
      new CartLinesUpdateEvent({ action: accao, context: 'cart', lines: linhas, promise: adiado.promise })
    );
    try {
      corpo.sections = seccoes().join(',');
      corpo.sections_url = window.location.pathname;
      const r = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(corpo),
      });
      const resposta = await r.json();
      let cart = resposta;
      if (!(resposta && Array.isArray(resposta.items) && 'item_count' in resposta)) {
        cart = await (await fetch(rotas().cart, { headers: { Accept: 'application/json' } })).json();
      }
      adiado.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          itemCount: cart.item_count,
          sections: resposta.sections || undefined,
          source: 'wod-gaveta',
          didError: !!resposta.status,
        },
      });
    } catch (erro) {
      adiado.reject(erro);
    }
  };
  fila = fila.then(tarefa, tarefa);
  return fila;
}

/* ---------- seguro de envio ----------
   O visto, o total e o botão de pagar mudam NO CLIQUE (os dois valores já vêm escritos pelo Liquid em
   data-total-com/sem e data-botao-com/sem). O servidor confirma a seguir e o tema redesenha. */
function pintarSeguro(el, ligar) {
  el.classList.toggle('ligado', ligar);
  const caixa = el.querySelector('input[data-wod-seguro]');
  if (caixa) caixa.checked = ligar;
  const gaveta = el.closest('#cart-drawer') || document;
  const total = gaveta.querySelector('.cart-totals__total-value');
  const valor = ligar ? el.dataset.totalCom : el.dataset.totalSem;
  if (total && valor) {
    const bdi = total.querySelector('bdi');
    if (bdi) bdi.innerHTML = valor;
    const t = document.createElement('div');
    t.innerHTML = valor;
    total.setAttribute('value', t.textContent);
  }
  const botao = gaveta.querySelector('#checkout .button-text');
  const texto = ligar ? el.dataset.botaoCom : el.dataset.botaoSem;
  if (botao && texto) botao.innerHTML = texto;
}

let seguroEmCurso = false;
function mudarSeguro(el, ligar) {
  const id = Number(el.dataset.variante);
  if (!id) return;
  pintarSeguro(el, ligar);
  seguroEmCurso = true;
  const gaveta = document.getElementById('cart-drawer');
  gaveta && gaveta.classList.add('wod-a-contar');
  const updates = {};
  updates[id] = ligar ? 1 : 0;
  mexer(el, rotas().update, { updates }, ligar ? 'add' : 'remove',
    [ligar ? { merchandiseId: String(id), quantity: 1 } : { id: String(id), quantity: 0 }])
    .finally(() => {
      seguroEmCurso = false;
      gaveta && gaveta.classList.remove('wod-a-contar');
    });
}

/* Ligado por omissão: entra uma vez por sessão quando o cesto tem artigos. Se o cliente o tirar, não
   volta. Cesto só com o seguro → sai sozinho. */
function afinarSeguro() {
  document.querySelectorAll('wod-seguro').forEach((el) => {
    if (seguroEmCurso) return;
    const tem = el.dataset.tem === 'true';
    if (window.wodSeguro) window.wodSeguro.tem = tem;
    const reais = parseInt(el.dataset.reais, 10) || 0;
    if (reais === 0 && tem) {
      mudarSeguro(el, false);
      return;
    }
    if (el.dataset.auto === 'true' && reais > 0 && !tem && !ss.get('wodSeguroAuto')) {
      ss.set('wodSeguroAuto', '1');
      mudarSeguro(el, true);
    }
  });
}

/* ---------- um só pedido (21/10) ----------
   Antes, o 1.º «Adicionar» fazia dois pedidos seguidos (o artigo e depois o seguro), cada um a redesenhar a
   gaveta: ~1,5 s. Agora o seguro vai junto no pedido do botão de compra (o FormData do tema passa a
   items[0] = artigo, items[1] = seguro). Se o pedido junto falhar, repete-se o original sem o seguro. */
const fetchOriginal = window.fetch.bind(window);
function juntarSeguro(corpo) {
  const sg = window.wodSeguro;
  if (!sg || !sg.v || sg.tem || ss.get('wodSeguroAuto') || !(corpo instanceof FormData)) return null;
  if (String(corpo.get('id')) === String(sg.v) || !corpo.get('id')) return null;
  const novo = new FormData();
  for (const [k, v] of corpo.entries()) {
    if (k === 'sections' || k === 'sections_url') novo.append(k, v);
    else if (k === 'id' || k === 'quantity' || k === 'selling_plan') novo.append('items[0][' + k + ']', v);
    else if (k.startsWith('properties[')) novo.append('items[0][properties][' + k.slice(11), v);
  }
  if (!corpo.get('quantity')) novo.append('items[0][quantity]', '1');
  novo.append('items[1][id]', String(sg.v));
  novo.append('items[1][quantity]', '1');
  return novo;
}
window.fetch = async function (url, opcoes) {
  const corpo = opcoes && opcoes.body;
  if (opcoes && /\/cart\/add(\.js)?$/.test(String(url).split('?')[0]) && corpo instanceof FormData) {
    const junto = juntarSeguro(corpo);
    if (junto) {
      try {
        const r = await fetchOriginal(url, { ...opcoes, body: junto });
        if (r.ok) {
          ss.set('wodSeguroAuto', '1');
          window.wodSeguro.tem = true;
          return r;
        }
      } catch (e) { /* cai no pedido original */ }
    }
  }
  return fetchOriginal(url, opcoes);
};

/* ---------- sugestões com variantes ---------- */
function varianteEscolhida(botao) {
  const cartao = botao.closest('.wod-up');
  const caixa = cartao && cartao.querySelector('[data-wod-opcoes]');
  if (!caixa) return botao.getAttribute('data-wod-juntar');
  let d;
  try { d = JSON.parse(caixa.querySelector('script').textContent); } catch (e) { return null; }
  const escolha = [...caixa.querySelectorAll('select')].map((s) => s.value).join('|');
  for (let i = 0; i < d.o.length; i++) {
    if (d.o[i].join('|') === escolha) {
      const preco = cartao.querySelector('.wod-up__p');
      if (preco && d.p && d.p[i]) preco.innerHTML = d.p[i];
      const foto = cartao.querySelector('.wod-up__img img');
      if (foto && d.m && d.m[i]) foto.src = d.m[i];
      return d.a[i] ? d.i[i] : null;
    }
  }
  return null;
}

/* ---------- barra dos degraus na moeda de quem está a ver ----------
   O Liquid escreve os degraus em cêntimos da moeda da LOJA (EUR) e o total na moeda do CLIENTE. Noutra
   moeda converte-se aqui com a taxa da Shopify e reescreve-se o que o Liquid escreveu. Na moeda da loja
   não se toca em nada. */
function dinheiro(centimos) {
  const moeda = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  const lingua = document.documentElement.lang || 'en';
  try {
    return new Intl.NumberFormat(lingua, { style: 'currency', currency: moeda, minimumFractionDigits: 2 }).format(centimos / 100);
  } catch (e) {
    return (centimos / 100).toFixed(2) + ' ' + moeda;
  }
}
function escrever(el, texto) { if (el && el.textContent !== texto) el.textContent = texto; }
function afinarBarra() {
  document.querySelectorAll('[data-wod-barra]').forEach((barra) => {
    if (barra.dataset.loja === barra.dataset.moeda) return;
    const taxa = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1);
    if (!(taxa > 0) || Math.abs(taxa - 1) < 1e-9) return;
    const total = parseInt(barra.dataset.total, 10) || 0;
    const d1 = Math.round(parseInt(barra.dataset.d1, 10) * taxa);
    const d2 = Math.round(parseInt(barra.dataset.d2, 10) * taxa);
    if (!d2) return;
    const estado = total >= d2 ? 'ganho' : total >= d1 ? 'meio' : 'inicio';
    const frase = estado === 'ganho' ? barra.dataset.fg
      : (estado === 'meio' ? barra.dataset.f2 : barra.dataset.f1).replace('@@', dinheiro(estado === 'meio' ? d2 - total : d1 - total));
    ['inicio', 'meio', 'ganho'].forEach((e) => barra.classList.toggle('wod-barra--' + e, e === estado));
    escrever(barra.querySelector('.wod-barra__frase'), frase);
    const risco = barra.querySelector('.wod-barra__calha i');
    const largura = Math.min(100, (total * 100) / d2).toFixed(2) + '%';
    if (risco && risco.style.width !== largura) risco.style.width = largura;
    const marcas = barra.querySelectorAll('.wod-barra__marca');
    const degs = barra.querySelectorAll('.wod-barra__deg');
    const um = barra.classList.contains('wod-barra--um');
    const valores = um ? [d2] : [d1, d2];
    const pcts = um ? [barra.dataset.p2] : [barra.dataset.p1, barra.dataset.p2];
    valores.forEach((v, i) => {
      if (marcas[i]) marcas[i].classList.toggle('atingida', total >= v);
      if (degs[i]) {
        degs[i].classList.toggle('atingido', total >= v);
        escrever(degs[i], dinheiro(v) + ' · ' + (pcts[i] || '') + (total >= v ? ' ✓' : ''));
      }
    });
  });
}

/* ---------- cronómetro (só se o dono o ligar) ----------
   A hora de arranque fica no sessionStorage: não volta aos 10:00 a cada clique. Ao chegar a zero recomeça. */
let relogio = null;
function tique() {
  const caixas = document.querySelectorAll('[data-wod-cron]');
  if (!caixas.length) { clearInterval(relogio); relogio = null; return; }
  caixas.forEach((c) => {
    const minutos = parseInt(c.dataset.min, 10) || 10;
    let desde = parseInt(ss.get('wodCronDesde'), 10);
    if (!desde || isNaN(desde)) { desde = Date.now(); ss.set('wodCronDesde', String(desde)); }
    let resta = minutos * 60 - Math.floor((Date.now() - desde) / 1000);
    if (resta <= 0) { desde = Date.now(); ss.set('wodCronDesde', String(desde)); resta = minutos * 60; }
    const mm = Math.floor(resta / 60), s = resta % 60;
    escrever(c.querySelector('[data-wod-cron-n]'), (mm < 10 ? '0' : '') + mm + ':' + (s < 10 ? '0' : '') + s);
  });
}
function afinarCron() {
  if (!document.querySelector('[data-wod-cron]')) return;
  tique();
  if (!relogio) relogio = setInterval(tique, 1000);
}

/* ---------- ligações ---------- */
document.addEventListener('change', (e) => {
  const caixa = e.target.closest && e.target.closest('input[data-wod-seguro]');
  if (caixa) {
    const el = caixa.closest('wod-seguro');
    if (!el) return;
    ss.set('wodSeguroAuto', '1');
    mudarSeguro(el, caixa.checked);
    return;
  }
  const lista = e.target.closest && e.target.closest('[data-wod-opcoes] select');
  if (lista) {
    const b = lista.closest('.wod-up').querySelector('button[data-wod-juntar]');
    if (b) b.disabled = !varianteEscolhida(b);
  }
});

document.addEventListener('click', (e) => {
  const juntar = e.target.closest && e.target.closest('button[data-wod-juntar]');
  if (juntar) {
    e.preventDefault();
    const id = Number(varianteEscolhida(juntar));
    if (!id) return;
    juntar.disabled = true;
    mexer(juntar, rotas().add, { items: [{ id, quantity: 1 }] }, 'add', [{ merchandiseId: String(id), quantity: 1 }])
      .finally(() => { if (juntar.isConnected) juntar.disabled = false; });
    return;
  }
  const limpar = e.target.closest && e.target.closest('button[data-wod-limpar]');
  if (limpar) {
    e.preventDefault();
    /* 2.º toque para confirmar: um dedo distraído não esvazia o cesto */
    if (!limpar.classList.contains('a-confirmar')) {
      limpar.classList.add('a-confirmar');
      const txt = limpar.querySelector('span');
      if (txt) { limpar.dataset.antes = txt.textContent; txt.textContent = limpar.dataset.confirmar; }
      setTimeout(() => {
        if (!limpar.isConnected) return;
        limpar.classList.remove('a-confirmar');
        if (txt && limpar.dataset.antes) txt.textContent = limpar.dataset.antes;
      }, 3500);
      return;
    }
    limpar.disabled = true;
    mexer(limpar, rotas().clear, {}, 'remove', []);
  }
});

/* A gaveta é redesenhada pelo tema a cada mudança: depois de cada redesenho, afinar outra vez. */
let marcado = false;
function afinar() {
  marcado = false;
  try { afinarBarra(); } catch (e) { /* nada */ }
  try { afinarCron(); } catch (e) { /* nada */ }
  try { afinarSeguro(); } catch (e) { /* nada */ }
}
function agendar() {
  if (marcado) return;
  marcado = true;
  requestAnimationFrame(afinar);
}
function iniciar() {
  afinar();
  const alvo = document.getElementById('cart-drawer') || document.body;
  new MutationObserver(agendar).observe(alvo, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-tem', 'data-reais', 'data-total'] });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
else iniciar();

/* 21/10: no computador, as sugestões passam para uma coluna encostada à esquerda da gaveta (como na Lugino).
   A caixa sai do resumo (que corta o que passa para fora) e vai para dentro do <dialog>; os cliques continuam
   a funcionar porque são apanhados no document. Quando a gaveta é redesenhada, volta a mudar-se. */
(function () {
  var mq = window.matchMedia('(min-width: 750px)');
  function arruma() {
    var c = document.querySelector('.cart-drawer__content'); var d = c && c.closest('dialog'); if (!d) return;
    var nova = c.querySelector('.cart-drawer__summary .wod-ups-caixa');
    var velhas = d.querySelectorAll(':scope > .wod-ups-caixa');
    if (!mq.matches) { velhas.forEach(function (v) { v.remove(); }); if (nova) nova.classList.remove('wod-lado'); return; }
    if (!nova) { if (!c.querySelector('.wod-ups-caixa')) velhas.forEach(function (v) { v.remove(); }); return; }
    velhas.forEach(function (v) { v.remove(); });
    var painel = c.closest('.cart-drawer__inner') || c;
    document.documentElement.style.setProperty('--wod-dw', painel.getBoundingClientRect().width + 'px');
    nova.classList.add('wod-lado'); d.appendChild(nova);
  }
  new MutationObserver(function () { if (document.querySelector('.cart-drawer__summary .wod-ups-caixa') && mq.matches) arruma(); }).observe(document.documentElement, { childList: true, subtree: true });
  if (mq.addEventListener) mq.addEventListener('change', arruma);
  document.addEventListener('DOMContentLoaded', arruma); arruma();
})();
